import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';

import './styles/ProfileAddButton.css';

export default function ProfileAddButton({ to, onClick = null, hidden = false }) {
  const navigate = useNavigate();

  // Si "hidden" es true, no renderiza el botón
  if (hidden) return null;

  return createPortal(
    <button 
      className="profile-add-button__container" 
      onClick={onClick ? onClick : () => navigate(to, { state: { from: true } })}
    >
      <div className="add-button-bar horizontal" />
      <div className="add-button-bar vertical" />
    </button>,
    document.getElementById("portal-generic-popup")
  );
}
